import { lazy, Suspense, type ReactNode } from 'react';

export function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-900">
      <div className="w-10 h-10 border-2 border-brand-500/30 border-t-brand-500 rounded-full animate-spin" />
    </div>
  );
}

export function LazyPage({ children }: { children: ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

export const LoginPage = lazy(() => import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage })));
export const RegisterPage = lazy(() =>
  import('@/pages/RegisterPage').then((m) => ({ default: m.RegisterPage })),
);
export const GuestPage = lazy(() => import('@/pages/GuestPage').then((m) => ({ default: m.GuestPage })));
export const JoinRoomPage = lazy(() =>
  import('@/pages/JoinRoomPage').then((m) => ({ default: m.JoinRoomPage })),
);
export const RoomsPage = lazy(() => import('@/pages/RoomsPage').then((m) => ({ default: m.RoomsPage })));
export const RoomPage = lazy(() => import('@/pages/RoomPage').then((m) => ({ default: m.RoomPage })));
export const SettingsPage = lazy(() =>
  import('@/pages/SettingsPage').then((m) => ({ default: m.SettingsPage })),
);
export const AdminDashboardPage = lazy(() =>
  import('@/pages/AdminDashboardPage').then((m) => ({ default: m.AdminDashboardPage })),
);
export const NotFoundPage = lazy(() =>
  import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
);
export const PwaDebugPage = lazy(() =>
  import('@/pages/PwaDebugPage').then((m) => ({ default: m.PwaDebugPage })),
);
export const PrivacyPage = lazy(() =>
  import('@/pages/PrivacyPage').then((m) => ({ default: m.PrivacyPage })),
);
